import React from 'react';
import {
    Grid,
    GridProps,
    Heading,
    Text,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'shared';
import { Helmet } from 'react-helmet-async';

export type NotFoundPageMainProps = GridProps & React.RefAttributes<HTMLDivElement>

export const NotFoundPageMain = (props: NotFoundPageMainProps) => {
    const navigate = useNavigate();
    return (
        <Grid
            {...props}
            padding="2rem"
            margin="0 auto"
            width="100%"
            maxWidth={{
                base: '425px',
                lg: '1280px',
            }}
            background="white"
            height="50vh"
        >
            <Helmet>
                <title>Не найдено 404</title>
                <meta name="description" content="Не найдено 404" />
                <meta property="og:title" content="Не найдено 404" />
            </Helmet>
            <Grid
                margin="auto"
                gap="1rem"
            >
                <Heading textAlign="center" fontSize="2rem">
                    Cтраница не найден
                </Heading>
                <Text textAlign="center" fontSize="1rem">
                    Если здесь что-то должно быть,
                    <br />
                    просьба связаться с технической поддержкой
                </Text>
                <Button onClick={() => navigate('/')}>
                    Вернуться на главную
                </Button>
            </Grid>
        </Grid>
    );
};
